import type { HTMLAttributes } from 'react';
import { cn } from '../utils';

function PageHeaderDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-base text-subtle-foreground', className)} {...props} />;
}

export { PageHeaderDescription };
